module.exports = __webpack_public_path__ + "img/icon.1e2d0c6e.svg";